export default __webpack_public_path__ + "static/Plots0002-33e0f8bcdd18aaf4d911ccbbd5f83ae1.jpg";